const convertBinaryToBool = (binary) => {
  if (!binary) return ''

  return Boolean(binary)
}

export default convertBinaryToBool
